import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/core/auth.service';

/**
 * With OIDC, the login, forgot-password and reset pages are auth-api's:
 * /auth/** sends the browser straight there, without showing anything.
 */
export const loginPageGuard: CanActivateFn = (route) => {
  if (!environment.OIDC) return true;

  inject(AuthService).startLogin(route.queryParamMap.get('returnUrl') ?? '/');
  return false;
};
